import React from "react";

type Props = {
  count: number;
  onAddItem: () => void;
};

export function EmptyState({ count, onAddItem }: Props) {
  const remaining = Math.max(0, 5 - count);
  const eyebrow = count === 0 ? "YOUR WARDROBE IS EMPTY" : "ALMOST THERE";
  const headline =
    count === 0 ? "Build your wardrobe" : `${remaining} more to unlock looks`;
  const progressPct = Math.min(100, (count / 5) * 100);

  return (
    <div style={{ padding: "0 6px" }}>
      <div
        style={{
          background: "#FFFCF8",
          border: "0.5px solid #E8E2D9",
          borderRadius: 20,
          padding: "28px 20px",
          textAlign: "center",
          marginTop: 14,
        }}
      >
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "#FAECE7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 14px",
          }}
        >
          <i
            className="ti ti-hanger"
            style={{ fontSize: 28, color: "#C84B2F" }}
            aria-hidden="true"
          />
        </div>
        <p
          className="l2f-type-section-header"
          style={{
            color: "#C84B2F",
            margin: "0 0 6px",
          }}
        >
          {eyebrow}
        </p>
        <p
          style={{
            fontFamily: "var(--font-display)",
            fontStyle: "italic",
            fontSize: 19,
            color: "#2C2820",
            margin: 0,
            lineHeight: 1.25,
          }}
        >
          {headline}
        </p>

        <div style={{ marginTop: 14 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 12,
              color: "#6B6560",
              marginBottom: 4,
            }}
          >
            <span>{count} added</span>
            <span>5 needed</span>
          </div>
          <div
            style={{
              width: "100%",
              background: "#F1EFE8",
              borderRadius: 999,
              height: 4,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${progressPct}%`,
                height: "100%",
                background: "#C84B2F",
                borderRadius: 999,
                transition: "width 200ms ease",
              }}
            />
          </div>
        </div>

        <p
          style={{
            fontSize: 12,
            color: "#6B6560",
            margin: "14px 0 18px",
            lineHeight: 1.5,
          }}
        >
          Snap your tops, bottoms, and shoes to start building daily outfit ideas.
        </p>

        <button
          type="button"
          onClick={onAddItem}
          style={{
            width: "100%",
            minHeight: 44,
            background: "#C84B2F",
            color: "#FFFCF8",
            border: "none",
            borderRadius: 999,
            padding: "12px 20px",
            fontSize: 15,
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Add items
        </button>
      </div>

      {count < 3 && (
        <div
          style={{
            background: "#FFFCF8",
            border: "0.5px solid #E8E2D9",
            borderRadius: 20,
            padding: "14px 16px",
            marginTop: 10,
            display: "flex",
            gap: 10,
            alignItems: "flex-start",
          }}
        >
          <i
            className="ti ti-info-circle"
            style={{ fontSize: 16, color: "#9B958E", flexShrink: 0, marginTop: 2 }}
            aria-hidden="true"
          />
          <p style={{ fontSize: 12, color: "#6B6560", margin: 0, lineHeight: 1.5 }}>
            You can also unlock <span style={{ fontStyle: "italic" }}>styled with what you own</span> looks once you add 3 items.
          </p>
        </div>
      )}
    </div>
  );
}
